import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Checkbox, createStyles } from "@mantine/core"

import { patchColumnData } from "app/static/frontend/sheets/sheet-action-creators"

import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

const useStyles = createStyles((theme, { editable }: { editable: boolean }) => ({
    checkbox: {
        ".mantine-Checkbox-input:checked": {
            cursor: editable ? "pointer" : "default",
        },
    },
}))

export const CheckCellComponent = ({
    children,
    columnIsEditable,
    sheetId,
    rowId,
    columnId,
    cellIsEditable,
    cellValueIsNotEditable,
    row,
    ...props
}) => {
    const { classes } = useStyles({ editable: columnIsEditable && cellIsEditable })

    return (
        <CellWrapper center {...props}>
            <Checkbox
                className={classes.checkbox}
                style={columnIsEditable && cellIsEditable ? { cursor: "pointer" } : {}}
                onClick={() =>
                    columnIsEditable && cellIsEditable
                        ? props.patchColumnData({
                              id: sheetId,
                              columnId,
                              rowId,
                              newValue: !children,
                              row,
                          })
                        : false
                }
                checked={children && !cellValueIsNotEditable}
                size="md"
            />
        </CellWrapper>
    )
}

CheckCellComponent.propTypes = {
    children: PropTypes.bool,
    columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    columnIsEditable: PropTypes.bool,
    patchColumnData: PropTypes.func.isRequired,
    rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sheetId: PropTypes.string.isRequired,
}

CheckCellComponent.defaultProps = {
    columnIsEditable: false,
}

export const CheckCell = connect(null, { patchColumnData })(CheckCellComponent)
